import { useContext } from 'react';

import { GuestContext } from '@/guest/provider/GuestContext';

export const useGuest = () => useContext(GuestContext);
